// SMART DEMO — Pusula Akademi asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 kpss + 4 english + 4 math + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Pusula Akademi" tamamen kurgu demo markadır.

export const PUSULA_AKADEMI_ASSET_ROOT = "/demo-presets/education/pusula-akademi";

export interface PusulaAkademiManifest {
  logo: string;
  kpss: string[];
  english: string[];
  math: string[];
  videos: string[];
}

export const PUSULA_AKADEMI_MANIFEST: PusulaAkademiManifest = {
  logo: `${PUSULA_AKADEMI_ASSET_ROOT}/logo/logo.webp`,
  kpss: [
    `${PUSULA_AKADEMI_ASSET_ROOT}/kpss/01.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/kpss/02.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/kpss/03.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/kpss/04.webp`,
  ],
  english: [
    `${PUSULA_AKADEMI_ASSET_ROOT}/english/01.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/english/02.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/english/03.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/english/04.webp`,
  ],
  math: [
    `${PUSULA_AKADEMI_ASSET_ROOT}/math/01.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/math/02.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/math/03.webp`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/math/04.webp`,
  ],
  videos: [
    `${PUSULA_AKADEMI_ASSET_ROOT}/videos/01.mp4`,
    `${PUSULA_AKADEMI_ASSET_ROOT}/videos/02.mp4`,
  ],
};